import React from "react";
import OrderList from "./OrderList";

function Submitted({ status }) {
  return <OrderList status={status} />;
}

export default Submitted;
